"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessesApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var BusinessesApi = /** @class */ (function (_super) {
    __extends(BusinessesApi, _super);
    function BusinessesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Accept a user invitation to join a business. This will create a new business user profile and add them to the specified business
     * Accept a user invitation to join a business.
     */
    BusinessesApi.prototype.acceptBusinessInvitationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling acceptBusinessInvitation.');
                        }
                        if (requestParameters.acceptInvitationRequest === null || requestParameters.acceptInvitationRequest === undefined) {
                            throw new runtime.RequiredError('acceptInvitationRequest', 'Required parameter requestParameters.acceptInvitationRequest was null or undefined when calling acceptBusinessInvitation.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/members".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.AcceptInvitationRequestToJSON)(requestParameters.acceptInvitationRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BusinessMemberResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Accept a user invitation to join a business. This will create a new business user profile and add them to the specified business
     * Accept a user invitation to join a business.
     */
    BusinessesApi.prototype.acceptBusinessInvitation = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.acceptBusinessInvitationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Cancel a user\'s invitation to a business.
     * Cancel a user\'s invitation to a business.
     */
    BusinessesApi.prototype.cancelBusinessInvitationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling cancelBusinessInvitation.');
                        }
                        if (requestParameters.invitationId === null || requestParameters.invitationId === undefined) {
                            throw new runtime.RequiredError('invitationId', 'Required parameter requestParameters.invitationId was null or undefined when calling cancelBusinessInvitation.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/invitations/{invitation_id}".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("invitation_id", "}"), encodeURIComponent(String(requestParameters.invitationId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Cancel a user\'s invitation to a business.
     * Cancel a user\'s invitation to a business.
     */
    BusinessesApi.prototype.cancelBusinessInvitation = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cancelBusinessInvitationRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates a new business
     * Create Business
     */
    BusinessesApi.prototype.createBusinessRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createBusinessRequest === null || requestParameters.createBusinessRequest === undefined) {
                            throw new runtime.RequiredError('createBusinessRequest', 'Required parameter requestParameters.createBusinessRequest was null or undefined when calling createBusiness.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateBusinessRequestToJSON)(requestParameters.createBusinessRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BusinessResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new business
     * Create Business
     */
    BusinessesApi.prototype.createBusiness = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createBusinessRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Invite a user to join a business.
     * Invite a user to a business.
     */
    BusinessesApi.prototype.createBusinessInvitationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling createBusinessInvitation.');
                        }
                        if (requestParameters.createBusinessInvitationRequest === null || requestParameters.createBusinessInvitationRequest === undefined) {
                            throw new runtime.RequiredError('createBusinessInvitationRequest', 'Required parameter requestParameters.createBusinessInvitationRequest was null or undefined when calling createBusinessInvitation.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/invitations".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.CreateBusinessInvitationRequestToJSON)(requestParameters.createBusinessInvitationRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CreateBusinessInvitationResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Invite a user to join a business.
     * Invite a user to a business.
     */
    BusinessesApi.prototype.createBusinessInvitation = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createBusinessInvitationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets all Businesses in AdCo, for internal super users only, used by the Admin UI.
     * Get all Businesses in AdCo
     */
    BusinessesApi.prototype.getAllBusinessesInternalRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.q !== undefined) {
                            queryParameters['q'] = requestParameters.q;
                        }
                        if (requestParameters.businessType !== undefined) {
                            queryParameters['business_type'] = requestParameters.businessType;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        if (requestParameters.sortDirection !== undefined) {
                            queryParameters['sort_direction'] = requestParameters.sortDirection;
                        }
                        if (requestParameters.sortField !== undefined) {
                            queryParameters['sort_field'] = requestParameters.sortField;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/internal/businesses",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetBusinessesInternalResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets all Businesses in AdCo, for internal super users only, used by the Admin UI.
     * Get all Businesses in AdCo
     */
    BusinessesApi.prototype.getAllBusinessesInternal = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAllBusinessesInternalRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns business based on a given business id.
     * Get Business by ID
     */
    BusinessesApi.prototype.getBusinessRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling getBusiness.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BusinessResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns business based on a given business id.
     * Get Business by ID
     */
    BusinessesApi.prototype.getBusiness = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBusinessRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns a specific member of a business.
     * Get a member of a business
     */
    BusinessesApi.prototype.getBusinessMemberRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling getBusinessMember.');
                        }
                        if (requestParameters.memberId === null || requestParameters.memberId === undefined) {
                            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling getBusinessMember.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/members/{member_id}".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("member_id", "}"), encodeURIComponent(String(requestParameters.memberId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BusinessMemberResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns a specific member of a business.
     * Get a member of a business
     */
    BusinessesApi.prototype.getBusinessMember = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBusinessMemberRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns all members and their roles (including invited users) within a given business. Users with expired or cancelled invitations are not returned.
     * Get business members by business id based on the requesting user\'s permission
     */
    BusinessesApi.prototype.getBusinessMembersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling getBusinessMembers.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/members".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetBusinessMembersResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns all members and their roles (including invited users) within a given business. Users with expired or cancelled invitations are not returned.
     * Get business members by business id based on the requesting user\'s permission
     */
    BusinessesApi.prototype.getBusinessMembers = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBusinessMembersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets businesses for logged-in user.
     * Get Businesses for Current User
     */
    BusinessesApi.prototype.getBusinessesRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetBusinessesResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets businesses for logged-in user.
     * Get Businesses for Current User
     */
    BusinessesApi.prototype.getBusinesses = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBusinessesRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Remove a member from a business.
     * Remove a member from a business
     */
    BusinessesApi.prototype.removeBusinessMemberRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling removeBusinessMember.');
                        }
                        if (requestParameters.memberId === null || requestParameters.memberId === undefined) {
                            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling removeBusinessMember.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/members/{member_id}".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("member_id", "}"), encodeURIComponent(String(requestParameters.memberId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Remove a member from a business.
     * Remove a member from a business
     */
    BusinessesApi.prototype.removeBusinessMember = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeBusinessMemberRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update the given existing business.
     * Update Business
     */
    BusinessesApi.prototype.updateBusinessRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling updateBusiness.');
                        }
                        if (requestParameters.updateBusinessRequest === null || requestParameters.updateBusinessRequest === undefined) {
                            throw new runtime.RequiredError('updateBusinessRequest', 'Required parameter requestParameters.updateBusinessRequest was null or undefined when calling updateBusiness.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.UpdateBusinessRequestToJSON)(requestParameters.updateBusinessRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BusinessResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update the given existing business.
     * Update Business
     */
    BusinessesApi.prototype.updateBusiness = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateBusinessRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update a member\'s business user profile.
     * Update a member\'s business user profile
     */
    BusinessesApi.prototype.updateBusinessMemberRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling updateBusinessMember.');
                        }
                        if (requestParameters.memberId === null || requestParameters.memberId === undefined) {
                            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling updateBusinessMember.');
                        }
                        if (requestParameters.updateBusinessMemberRequest === null || requestParameters.updateBusinessMemberRequest === undefined) {
                            throw new runtime.RequiredError('updateBusinessMemberRequest', 'Required parameter requestParameters.updateBusinessMemberRequest was null or undefined when calling updateBusinessMember.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/members/{member_id}".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("member_id", "}"), encodeURIComponent(String(requestParameters.memberId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.UpdateBusinessMemberRequestToJSON)(requestParameters.updateBusinessMemberRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BusinessMemberResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update a member\'s business user profile.
     * Update a member\'s business user profile
     */
    BusinessesApi.prototype.updateBusinessMember = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateBusinessMemberRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update a business member\'s role
     * Update a business member\'s role
     */
    BusinessesApi.prototype.updateBusinessMemberRoleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.businessId === null || requestParameters.businessId === undefined) {
                            throw new runtime.RequiredError('businessId', 'Required parameter requestParameters.businessId was null or undefined when calling updateBusinessMemberRole.');
                        }
                        if (requestParameters.memberId === null || requestParameters.memberId === undefined) {
                            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling updateBusinessMemberRole.');
                        }
                        if (requestParameters.updateBusinessMemberRoleRequest === null || requestParameters.updateBusinessMemberRoleRequest === undefined) {
                            throw new runtime.RequiredError('updateBusinessMemberRoleRequest', 'Required parameter requestParameters.updateBusinessMemberRoleRequest was null or undefined when calling updateBusinessMemberRole.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/businesses/{business_id}/members/{member_id}/role".replace("{".concat("business_id", "}"), encodeURIComponent(String(requestParameters.businessId))).replace("{".concat("member_id", "}"), encodeURIComponent(String(requestParameters.memberId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.UpdateBusinessMemberRoleRequestToJSON)(requestParameters.updateBusinessMemberRoleRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BusinessMemberResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update a business member\'s role
     * Update a business member\'s role
     */
    BusinessesApi.prototype.updateBusinessMemberRole = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateBusinessMemberRoleRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return BusinessesApi;
}(runtime.BaseAPI));
exports.BusinessesApi = BusinessesApi;
